import { GET_SETTINGS } from "./actionTypes";
import { GET_SETTINGS_URL } from "../../configs";
import Axios from "axios";

export const getSettings = () => (dispatch) => {
	console.log("Fetching settings from:", GET_SETTINGS_URL);
	
	Axios.post(GET_SETTINGS_URL)
		.then((response) => {
			console.log("Settings loaded successfully:", response.data);
			const settings = response.data;
			return dispatch({ type: GET_SETTINGS, payload: settings });
		})
		.catch(function(error) {
			console.error("Error loading settings:", error);
			console.error("Settings URL:", GET_SETTINGS_URL);
			console.error("Error details:", error.response || error.message);
		});
};
